import $ from 'jquery';

export const elements = {
    call: '.js-SlidingBox-Call',
    callCaption: '.js-SlidingBox-CallCaption',
    holder: '.js-SlidingBox-Holder',
    box: '.js-SlidingBox-Box',
};

export const callCaptionLabelSwitch = ($target, stage) => {
    const isCollapsed = $target.data('ui-slidingbox-callcaption-collapsed');
    const isExpanded = $target.data('ui-slidingbox-callcaption-expanded');

    if (isCollapsed !== 'undefined' || isExpanded !== 'undefined') {
        $target.html(((stage === 'collapse') ? isCollapsed : isExpanded));
    }
};

export const toggle = ($call, $callCaption, $holder, $box) => {
    const $visibleBox = $('.js-SlidingBox-Box.fn-visible');
    const $visibleBoxCall = $visibleBox.parent(elements.holder).find(elements.call);
    const $caption = $visibleBox.parent(elements.holder).find(elements.callCaption);

    $call.toggleClass('fn-active');

    if ($call.hasClass('fn-active')) {
        $visibleBox.removeClass('fn-visible');
        $visibleBoxCall.removeClass('fn-active');

        $box.addClass('fn-visible');

        callCaptionLabelSwitch($caption, 'collapse');
        callCaptionLabelSwitch($callCaption, 'expand');
    } else {
        $box.removeClass('fn-visible');

        callCaptionLabelSwitch($caption, 'expand');
        callCaptionLabelSwitch($callCaption, 'collapse');
    }
};

export const onClick = function () {
    const $this = $(this);
    const $holder = $this.parent(elements.$holder);
    const $box = $holder.find(elements.box);
    const $callCaption = $holder.find(elements.callCaption);

    toggle($this, $callCaption, $holder, $box);
};

export default {
    init(params) {
        params.$document.on('click', elements.call, onClick);
    },
};



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/sliding-box.js